import { render } from "./Miscellaneous.vue?vue&type=template&id=3c5c7518&ts=true"
import script from "./Miscellaneous.vue?vue&type=script&lang=ts"
export * from "./Miscellaneous.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__